import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SharedNavbar from '../components/SharedNavbar';
import './EventsPage.css';
import calendrier from '../assets/images/calendrier.png';

const categories = [
  'AI and ML',
  'CDMP',
  'Conference',
  'Course',
  'DAMA Tunisia Updates',
  'Data Governance',
  'Data Literacy',
  'Data Management',
  'Meet Ups',
  'Member-only',
  'Newsletter',
  'Public',
  'Webinars',
];

const EventsPage = () => {
  const [activeCategory, setActiveCategory] = useState(null);

  return (
    <div className="events-page">
      <SharedNavbar />

      {/* ===== HERO ===== */}
      <section className="events-hero">
        <div className="events-hero-content">
          <h1>Events</h1>
          <p>
            Join webinars, training, working groups, and annual conferences —
            your gateway to learning, connecting, and advancing in data management.
          </p>
        </div>
      </section>

      {/* ===== BODY ===== */}
      <section className="events-body">
        <div className="events-container">
          <div className="events-layout">

            {/* ── SIDEBAR ── */}
            <aside className="events-sidebar">
              <h2>Categories</h2>
              <ul>
                {categories.map((cat) => (
                  <li
                    key={cat}
                    className={activeCategory === cat ? 'active' : ''}
                    onClick={() => setActiveCategory(activeCategory === cat ? null : cat)}
                  >
                    {cat}
                  </li>
                ))}
              </ul>
            </aside>

            {/* ── CONTENU PRINCIPAL ── */}
            <div className="events-main">

              {/* Info + boutons Past Events */}
              <div className="events-info-row">

                <div className="events-info-text">
                  <p><strong>You can find our upcoming events below.</strong></p>
                  <p>To view past events, choose Past Public or Member Events.</p>
                </div>

                <div className="events-info-text">
                  <p><strong>Not already a member?</strong></p>
                  <p>
                    <Link to="/membership" className="events-link">
                      Click here
                    </Link>{' '}
                    to learn more about our membership tiers and the benefits of DAMA Tunisia membership.
                  </p>
                </div>

                {/* Boutons empilés */}
                <div className="events-signposts">
                  <a href="#past-public" className="events-signpost sp-public">
                    Past Public Events
                  </a>
                  <a href="#past-members" className="events-signpost sp-members">
                    Past Member Events
                  </a>
                </div>

              </div>

              {/* Filtre catégorie active */}
              {activeCategory && (
                <div className="events-cat-msg">
                  <h3>Category: <span>{activeCategory}</span></h3>
                  <p>No events available in this category yet. Check back soon!</p>
                  <button onClick={() => setActiveCategory(null)} className="events-reset-btn">
                    ← View all categories
                  </button>
                </div>
              )}

              {/* Upcoming events */}
              <div className="events-upcoming">
                <div className="events-coming-soon">
                  <img src={calendrier} alt="Events" className="events-coming-icon-img" />
                  <h3>Upcoming Events</h3>
                  <p>
                    Events will be listed here soon. Stay tuned for upcoming webinars,
                    training sessions and meetups from DAMA Tunisia!
                  </p>
                  <Link to="/membership" className="events-join-btn">
                    Become a member to get notified
                  </Link>
                </div>
              </div>

              {/* Past Public Events */}
              <div id="past-public" className="events-past-section">
                <div className="events-past-header public-header">
                  Past Public Events
                </div>
                <div className="events-past-body">
                  <p>No past public events yet. Check back soon!</p>
                </div>
              </div>

              {/* Past Member Events */}
              <div id="past-members" className="events-past-section">
                <div className="events-past-header members-header">
                  Past Member Events
                </div>
                <div className="events-past-body">
                  <p>No past member events yet. Check back soon!</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="events-cta">
        <div className="events-container">
          <div className="events-cta-grid">

            <Link to="/membership" className="events-cta-btn">
              <div className="events-cta-text">
                <strong>Become a member</strong>
                <span>Join today and access all our resources</span>
              </div>
            </Link>

            <Link to="/news" className="events-cta-btn">
              <div className="events-cta-text">
                <strong>News</strong>
                <span>Latest updates from DAMA Tunisia</span>
              </div>
            </Link>

            <Link to="/about" className="events-cta-btn">
              <div className="events-cta-text">
                <strong>Sponsor us</strong>
                <span>Connect with the Tunisian data community</span>
              </div>
            </Link>

          </div>
        </div>
      </section>

    </div>
  );
};

export default EventsPage;